import { Component, OnInit, Input, Optional, Inject, HostListener} from '@angular/core';
import { AppDataStore, PermissionCheckerService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';
import { Location } from '@angular/common';
import { NxiMobileService } from '../services/nxi-mobile.service';
import moment from 'moment-timezone';

@Component({
    selector: 'modern-mobile-navigation',
    templateUrl: 'modern-mobile-nav.component.html'
})
export class ModernMobileNavComponent implements OnInit {
    menuItems: any[];
    selectedPageId: string;
    navigation: NxiNavigation;
    showPostLogin: boolean = true;
    isOpen: boolean = false;
    @Input() isMobileTheme: boolean;
    @Input() isTabletTheme: boolean;
    @Input() showLanguageSwitch: boolean = false;
    parentpage: string;
    isLoggedIn: boolean = false;
    parentSelectedPageId: string;
    menuId: string;
    isDisclosurePage: boolean;
    appSettings: any;
    isEdelEnabled: boolean;
    entitledForContactUs: boolean;
    url: string = '';
    linkUrl: string;
    isSSO: boolean = false;
    isEquipt: boolean = false;
    isEntitledForAccountOpening: boolean = false;
    isNewAccOpenEnabled: boolean = false;
    hideAcctOpening: boolean = false;
    isSSOLogoutHide: boolean = false;
    date: any;
    time: any;
    hideLastLoginTime: boolean = false;
    @Input('menuItems') set menu(data: any) {
        console.log('DATA IN', data)
        if (data && data.length > 0) {
          this.menuItems = data;
          // Set menu list and selected menu for the page.
          this.navigationService.setSelectedPageMenu(this.url, this.menuItems);
          this.selectedPageId = this.navigationService.getParentPageId();
        }
        console.log('MENU ITEMS OUT', this.menuItems);
    }

    constructor(
        protected navigationService: PortalNavigationService,
        protected location: Location,
        private mobileService: NxiMobileService,
        private authorizationService: PermissionCheckerService,
        private translationService: PershingTranslationService,
        private appData: AppDataStore,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.appSettings = appSettings;
        this.isEquipt = appSettings.ibdConfigMap.community === 'equipt' ? true : false;
        this.isLoggedIn = (appSettings && appSettings.isLoggedIn);
        this.linkUrl = appSettings.postLoginEquiptUrl;
        this.url = this.location.path(false);
        let urlArray = this.url.split('/');
        if (urlArray[2] === 'disclosure') {
            this.isDisclosurePage = true;
        } else {
            this.isDisclosurePage = false;
        }
        this.entitledForContactUs = this.authorizationService.isEntitled("CONTACT_BROKERAGE || ABOUT_US || FINANCIAL_ADVISOR || OUTSIDE_LINKS || DOWNLOAD_FORMS")
        this.isSSO = appSettings?.isAdvisor || appSettings?.isVendorSso;
        this.isEntitledForAccountOpening = this.authorizationService.isEntitled("ACCOUNT_OPENING");
        this.isNewAccOpenEnabled = this.appSettings.ibdConfigMap?.isNewAccOpenEnabled ?? this.isNewAccOpenEnabled;
        this.hideAcctOpening = this.appSettings.ibdConfigMap?.disableAcctOpenLink ?? this.hideAcctOpening;
        this.isSSOLogoutHide = appSettings.isSSOLogoutHide;
        
    }

    handleChildNavigation(parentpage, childPage): void {
        this.navigation = new NxiNavigation();
        this.navigation.childPage = childPage;
        this.navigation.parentPage = parentpage;
        this.selectedPageId = childPage.id;
        this.parentSelectedPageId = parentpage.id;
        // For native mobile page , we need to do an href to make
        // the native app team capture the href event
        if (childPage.id === 'mobiledeposit') {
            location.href = '/nxi/mobile-deposit';
            return;
        }
        this.navigationService.handleNavigation(this.navigation);
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }

    handleNavigation(parentpage): void {
        this.navigation = new NxiNavigation();
        this.navigation.parentPage = parentpage;
        this.navigationService.handleNavigation(this.navigation);
        this.menuId = parentpage.id;
        this.parentSelectedPageId = parentpage.id;
        this.selectedPageId = '';
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }
    handleNavigationLink(parentpage: any): void {
        if (parentpage.id === 'equipt') {
            window.location.href = this.linkUrl;
        } else if (parentpage.id === 'returntobanking') {
            window.location.href = parentpage.linkUrl;
        }else {
            window.open(parentpage.linkUrl);
        }
        return;
    }
    ngOnInit() {
        this.mobileService.change.subscribe(isOpen => {
            this.isOpen = isOpen;

            const button = document.getElementById('menu-btn-toggle');
            const list = document.querySelector('.fw-SideNav');
            if (this.isOpen) {
                document.body.classList.add('.fw-SideNav');
                // Append the list to the button's parent node
                if(button != null){
                  button.parentNode.appendChild(list);
                }
            } else {
              // Remove this list
            document.body.classList.remove('.fw-SideNav');

           }
        });
        if (this.isLoggedIn) {
            let suppressGoPaperless = false;
            if (this.appSettings.ibdConfigMap.suppressGoPaperless !== undefined) {
                suppressGoPaperless = this.appSettings.ibdConfigMap.suppressGoPaperless;
            }
            // Certain IBDs need ELECTRONIC_NOTIFICATION enabled
            // but should not be shown with GoPaperless and Edelivery Preferences
            if (this.authorizationService.isEntitled('ELECTRONIC_NOTIFICATION') && (!suppressGoPaperless)) {
                this.isEdelEnabled = true;
            }
        }
        if (this.appSettings.ibdConfigMap.community === 'equipt' && this.appSettings.isVendorSso) {
            this.hideLastLoginTime = true;
        } else {
            this.hideLastLoginTime = false;
            this.getLastLogonTime();
        }
    }
    logout(): void {
        let billsuiteOpener = this.appData.get('billsuiteOpener');
        if (billsuiteOpener) {
            billsuiteOpener.close();
        }
        document.dispatchEvent(new CustomEvent('portal.DASFLogoutEvent'));
    }
    toggle(): void {
        this.mobileService.toggle();
    }

    removeChildMenu(mainMenu: any, childMenu: string) {
        if (mainMenu && mainMenu.children && mainMenu.children.length > 0) {
            for (let i = 0; i < mainMenu.children.length; i++) {
                if (mainMenu.children[i] && mainMenu.children[i].id === childMenu) {
                    mainMenu.children.splice(i, 1);
                    return;
                }
            }
        }
    }

    // Use cases - This is all about closing the sidenav if user clicks on some elements that is not handled or require additonal
    // handling e.g. the 'Menu' tab itself.
    // 1. User clicks on other than the 'Menu' tab within MODERN-NXI-MOBILE and sidenav is OPEN, close the sidenav.
    // 2. User clicks on the 'Menu' tabs within NXI-MOBILE, just turn off the flag only. Toggle is already handled in init above.
    // 3. User clicks on anywhere besides side nav and tab list and side nav is open, close the side nav.
    @HostListener('document:click', ['$event']) onClick(event: Event) {
        let element = event.target as HTMLElement;
        while (element) {
            if (element.tagName.toUpperCase() === 'MODERN-MOBILE-NAVIGATION' || element.tagName.toUpperCase() === 'MODERN-NXI-MOBILE') {
                // For use case #1.
                if (this.mobileService.isOpen && !this.mobileService.isMobileMenuTabClickEvent) {
                    this.mobileService.toggle();
                    // For use case #2.
                } else if (this.mobileService.isMobileMenuTabClickEvent) {
                    this.mobileService.mobileMenuTabClickEvent(false);
                }
                return;
            } else if (element.tagName.toUpperCase() === 'MOD-INDICES') {
                event.preventDefault();
                return;
            } else if (element.tagName.toUpperCase() === 'LANGUAGE-SWITCH') {
                event.preventDefault();
                return;
            } else if (element.tagName.toLocaleUpperCase() === 'MAT-EXPANSION-PANEL-HEADER') {
                event.preventDefault();
                return;
            }
            element = element.parentElement;
        }
        // For use case #3.
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }
    expandMenuItem(id: string) {
        this.menuId = id;
    }
    openAnAccount(): void {
        document.dispatchEvent(
          new CustomEvent("portal.gotoview", {
            detail: {
              gotoPage: "/nxi/account-types-nao",
              gotoParams: { fromLogin: true },
            },
          })
        );

      }
    getLastLogonTime(): void {
        this.mobileService.getLastLoginTime(' ', ' ').subscribe(
            response => {
                // this.passwordExpiryDays = response.passwordExpiryDays;
                if (response?.lastLogonTime) {
                    this.date = moment(new Date(response.lastLogonTime)).format("MMM D, YYYY");
                    this.time = moment(new Date(response.lastLogonTime)).format("hh:mm A");
                } else {
                    this.date = moment.tz(new Date(), "America/New_York").format("MMM D, YYYY");
                    this.time = moment.tz(new Date(), "America/New_York").format("hh:mm A");
                }
            }
        );
    }
}
